import { ROUTES } from "../../../../components/shared/constant";

/**
 * The pages the header's Location choice filters (D27). Exact paths: a job's or
 * an applicant's own page, and the offer sub-pages, are not lists and are not
 * filtered, so the switcher shows there but is disabled.
 */
const FILTERED_PAGES = new Set<string>([
  ROUTES.HOME,
  ROUTES.DASHBOARD,
  ROUTES.APPLICANTS,
  ROUTES.JOBS,
  ROUTES.SCHEDULED_TOURS,
  ROUTES.OFFERS,
  ROUTES.REPORTS,
  ROUTES.CANDIDATE_INBOX,
  // Every page listing job-linked data follows the header: offers, onboarding
  // packets and bulk uploads each belong to a job.
  ROUTES.OFFER_ANALYTICS,
  ROUTES.ONBOARD_PACKETS,
  ROUTES.BULK_UPLOADS,
]);

export function locationFilterAppliesTo(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, "") || "/";
  return FILTERED_PAGES.has(path);
}

/** The pages with their own Department filter (ScopeFilters). */
const DEPARTMENT_PAGES = new Set<string>([ROUTES.APPLICANTS, ROUTES.JOBS, ROUTES.REPORTS]);

export function departmentFilterAppliesTo(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, "") || "/";
  return DEPARTMENT_PAGES.has(path);
}

export const NOT_FILTERED_TOOLTIP = "This page isn't filtered by location.";
